import { RefreshCw } from 'lucide-react';
import { Button } from '@dd/ui';
import { Logo } from './Logo';
import { useT } from '@/lib/i18n';
import { applyUpdate } from '@/lib/pwa';

/** 426 upgrade_required (Guide §19): the installed app is older than the server's minimum. */
export function UpgradeRequired() {
  const { t } = useT();
  return (
    <div className="mx-auto flex min-h-dvh max-w-sm flex-col items-center justify-center gap-4 px-6 text-center">
      <Logo size={64} />
      <h1 className="text-xl font-extrabold">{t('অ্যাপ আপডেট করতে হবে', 'Please update the app')}</h1>
      <p className="text-ink-2">{t('নতুন ভার্সন ছাড়া ডেটা সুরক্ষিতভাবে সিঙ্ক করা যাবে না। আপনার ডেটা ফোনে নিরাপদ আছে।', 'Data cannot be synced safely without the new version. Your data is safe on this phone.')}</p>
      <Button size="lg" block icon={<RefreshCw size={18} />} onClick={() => void applyUpdate()}>{t('এখনই আপডেট', 'Update now')}</Button>
    </div>
  );
}
